import styled, { css } from 'styled-components';

const TitleBar = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  padding: 0 44px 0 24px;
  min-height: 56px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 18px 0;
`;

const Title = styled.h4`
  ${({ theme }) => css`
    ${theme.heading[4].bold};
    color: ${theme.text.onSurface.strong};
    margin-bottom: 2px;
  `};
`;
const Description = styled.span`
  ${({ theme }) => css`
    ${theme.paragraph.small.normal};
    color: ${theme.text.onSurface.subtle};
  `};
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-grow: 1;
`;

export { TitleBar, TextWrapper, Title, Description, ComponentWrapper };
